import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments';
import {
  PreferencesResponse,
  UpdatePreferencesDto,
} from '../interfaces/preferences.interface';

@Injectable({
  providedIn: 'root',
})
export class PreferencesService {
  private apiUrl = `${environment.apiUrl}/preferences`;

  constructor(private http: HttpClient) {}

  getMyPreferences(): Observable<PreferencesResponse> {
    return this.http.get<PreferencesResponse>(`${this.apiUrl}`);
  }

  updateMyPreferences(payload: UpdatePreferencesDto): Observable<PreferencesResponse> {
    return this.http.put<PreferencesResponse>(`${this.apiUrl}`, payload);
  }
}


